import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=9c562874&scoped=true&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"
import style0 from "./Information.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Information.vue?vue&type=style&index=1&id=9c562874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c562874",
  null
  
)

export default component.exports